import React from 'react';
import { motion } from 'framer-motion';

const steps = [
  { number: '01', title: 'Research & Development', description: 'We dive deep into your business, goals, and target audience' },
  { number: '02', title: 'Strategy', description: 'Custom roadmap tailored to your unique needs and objectives' },
  { number: '03', title: 'Execution', description: 'Expert implementation with precision and attention to detail' },
  { number: '04', title: 'Optimization', description: 'Continuous improvement driven by data and performance metrics' },
];

export default function Process() {
  return (
    <section id="process" className="py-32 px-4">
      <div className="max-w-7xl mx-auto">
        <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }} className="text-center mb-20">
          <motion.span whileHover={{ scale: 1.05 }}
            className="inline-block px-6 py-2 bg-gradient-to-r from-cyan-500/10 to-orange-500/10 border border-cyan-500/20 rounded-full text-sm font-semibold text-cyan-400 mb-6 backdrop-blur-sm">
            Our Process
          </motion.span>
          <h2 className="text-5xl md:text-7xl font-black mb-6">
            How We <span className="bg-gradient-to-r from-cyan-400 to-orange-500 bg-clip-text text-transparent">Work</span>
          </h2>
        </motion.div>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((s, i) => (
            <motion.div key={s.number} initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }} transition={{ delay: i * 0.15 }} whileHover={{ y: -8 }} className="relative">
              <div className="bg-gradient-to-br from-gray-50/50 dark:from-gray-900/50 to-white/50 dark:to-black/50 p-8 rounded-2xl border border-gray-200 dark:border-gray-800 hover:border-cyan-500/40 transition-all backdrop-blur-sm h-full">
                <div className="text-7xl font-black bg-gradient-to-br from-cyan-400/20 to-orange-400/20 bg-clip-text text-transparent mb-6">{s.number}</div>
                <h3 className="text-2xl font-bold mb-4 text-gray-900 dark:text-white">{s.title}</h3>
                <p className="text-gray-600 dark:text-gray-400 leading-relaxed">{s.description}</p>
              </div>
              {i < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-3 w-6 h-px bg-gradient-to-r from-cyan-500/50 to-transparent" />
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
